import { WaitForQueries } from '@graphcommerce/ecommerce-ui'
import { PageOptions } from '@graphcommerce/framer-next-pages'
import {
  ApolloCartErrorAlert,
  EmptyCart,
  useCartQuery,
} from '@graphcommerce/magento-cart'
import { CartPageDocument } from '@graphcommerce/magento-cart-checkout'
import { StoreConfigDocument } from '@graphcommerce/magento-store'
import {
  GetStaticProps,
  FullPageMessage,
} from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { CircularProgress } from '@mui/material'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Image from 'next/image'
import Link from 'next/link'
import { useContext } from 'react'
// eslint-disable-next-line import/no-cycle
import { LayoutOverlayProps } from ".."
import { ModalContext } from '../../context/context'
import { graphqlSharedClient } from '../../lib/graphql/graphqlSsrClient'
import { Money } from '../Money'



type Props = Record<string, unknown>
type GetPageStaticProps = GetStaticProps<LayoutOverlayProps, Props>

function CartPage() {
  const cart = useCartQuery(CartPageDocument, { returnPartialData: true, errorPolicy: 'all' })
  const { data, error } = cart
  const hasItems =
    (data?.cart?.total_quantity ?? 0) > 0 &&
    typeof data?.cart?.prices?.grand_total?.value !== 'undefined'

  const useModal = useContext(ModalContext);


  return (
    <WaitForQueries
      waitFor={cart}
      fallback={
        <FullPageMessage icon={<CircularProgress />} title={<Trans id='Loading' />}>
          <Trans id='This may take a second' />
        </FullPageMessage>
      }
    >
      <div className='p-2 flex flex-col gap-6 h-[calc(100%-100px)] relative text-default-900 ' >

        {hasItems ? (
          <div className='flex flex-col gap-8'>
            {data?.cart?.items?.map((item, index) => (<div className='flex flex-row w-full items-start justify-start' key={index}>

              {item?.product.thumbnail && (
                <Image
                  src={item?.product?.thumbnail?.url}
                  alt={item?.product?.name}
                  width={50}
                  height={50}
                />
              )}
              <div className='flex flex-col gap-2 items-start w-full'>
                <Link href={`/p/${item?.product.url_key}`} className='text-sm hover:text-primary-500 transition-colors'>
                  {item?.product.name}
                </Link>
                <div className='flex flex-row w-full justify-between'>
                  <span className='flex flex-row items-center w-full gap-1 text-base text-secondary-400 text-secondary-500'>
                    <Money showCurrency={false} {...item?.prices?.price} />
                    <span className='text-xs text-default-900 '>
                      تومان
                    </span>
                  </span>

                  <span className='w-full'>
                    {`تعداد :${item?.quantity}`}
                  </span>

                </div>
              </div>

            </div>))}
            <ApolloCartErrorAlert error={error} />


          </div>
        ) : (
          <EmptyCart>{error && <ApolloCartErrorAlert error={error} />}</EmptyCart>
        )}


        <div className='flex flex-col text-xs items-center  justify-between absolute bottom-0 left-0 right-0'>
          <p className='w-full flex flex-row justify-between p-2'>جمع جزء:
            <span className='flex flex-row gap-1 text-sm font-light text-secondary-500'>
              {data?.cart && <Money showCurrency={false} {...data?.cart?.prices?.grand_total} />}
              <span className='text-xs text-default-900 '>تومان</span>
            </span>
          </p>
          <section className='flex flex-row w-full text-default-800 font-medium text-sm justify-around'>
            <Link href='/checkout/cart'>
              <button className='p-2 rounded-sm' onClick={useModal.close}>مشاهده سبد خرید</button>
            </Link>
            <Link href='/checkout/onePage'>
              <button className='p-2 rounded-sm' onClick={useModal.close}>تسویه حساب</button>
            </Link>
          </section>
          {/* <CartStartCheckout {...data?.cart} /> */}
        </div>
      </div>
    </WaitForQueries>
  )
}

const pageOptions: PageOptions<LayoutOverlayProps> = {
  overlayGroup: 'cart',
  layoutProps: { variantMd: 'bottom', variantSm: 'bottom' },
}
CartPage.pageOptions = pageOptions

// eslint-disable-next-line import/no-default-export
export default CartPage

export const getStaticProps: GetPageStaticProps = async ({ locale }) => {
  const client = graphqlSharedClient(locale)
  const conf = client.query({ query: StoreConfigDocument })

  return {
    props: {
      apolloState: await conf.then(() => client.cache.extract()),
    },
  }
}
